import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const premiumBuses = [
  {
    srNo: 12,
    capacity: 'SCANIA 45',
    rate: '₹24000',
    extraKm: '₹80',
    local: '₹18000',
    extraHour: '₹1000',
    mumbai: '₹24000',
    mahabaleshwar: '₹24000',
    shirdi: 'On Call',
  },
  {
    srNo: 13,
    capacity: 'VOLVO 45',
    rate: '₹24000',
    extraKm: '₹80',
    local: '₹18000',
    extraHour: '₹1000',
    mumbai: '₹24000',
    mahabaleshwar: '₹24000',
    shirdi: 'On Call',
  }
];

const SpecialPremiumBuses = () => {
  const phoneNumber = '917353109555'; // Without '+' for wa.me
  const sendWhatsApp = (capacity) => {
    const message = `Hi, I want to book a ${capacity} bus.`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section style={{ backgroundColor: '#F9FEFF', padding: '20px' }}>
      <div className="container">
        <h5 className="text-white bg-darkk p-3 rounded-top">SPECIAL PREMIUM BUSES</h5>
        <div className="table-responsive">
          <table className="table table-bordered text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th className='table-darkk'>SR.NO</th>
                <th className='table-darkk'>SEATING CAPACITY</th>
                <th className='table-darkk'>PER KM RATE (300 KM PACKAGE)</th>
                <th className='table-darkk'>EXTRA KM</th>
                <th className='table-darkk'>8/80 PUNE LOCAL</th>
                <th className='table-darkk'>EXTRA HOUR</th>
                <th className='table-darkk'>MUMBAI UPTO 350 KM</th>
                <th className='table-darkk'>MAHABALESHWAR UPTO 300 KMS</th>
                <th className='table-darkk'>SHIRDI (450 KM)</th>
                <th className='table-darkk'>BOOK NOW</th>
              </tr>
            </thead>
            <tbody>
              {premiumBuses.map((bus, index) => (
                <tr key={index} className={index % 2 !== 0 ? 'table-light' : ''}>
                  <td>{bus.srNo}</td>
                  <td>{bus.capacity}</td>
                  <td>{bus.rate}</td>
                  <td>{bus.extraKm}</td>
                  <td>{bus.local}</td>
                  <td>{bus.extraHour}</td>
                  <td>{bus.mumbai}</td>
                  <td>{bus.mahabaleshwar}</td>
                  <td>{bus.shirdi}</td>
                  <td>
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => sendWhatsApp(bus.capacity)}
                    >
                      Book Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default SpecialPremiumBuses;
